import { Injectable, signal } from '@angular/core';

import { environment } from '../../environments/environment';

/* eslint-disable no-console -- intentional console wrapper */

@Injectable({
  providedIn: 'root'
})
export class LoggerService {
  public debugMode = signal(!environment.production);

  toggleDebugMode(): void {
    this.debugMode.update(v => !v);
  }

  log(...args: unknown[]): void {
    if (this.debugMode()) {
      console.log(...args);
    }
  }

  info(...args: unknown[]): void {
    if (this.debugMode()) {
      console.info(...args);
    }
  }

  warn(...args: unknown[]): void {
    if (this.debugMode()) {
      console.warn(...args);
    }
  }

  error(...args: unknown[]): void {
    if (this.debugMode()) {
      console.error(...args);
    }
  }

  debug(...args: unknown[]): void {
    if (this.debugMode()) {
      console.debug(...args);
    }
  }

  group(...args: unknown[]): void {
    if (this.debugMode()) {
      console.group(...args);
    }
  }

  groupCollapsed(...args: unknown[]): void {
    if (this.debugMode()) {
      console.groupCollapsed(...args);
    }
  }

  groupEnd(): void {
    if (this.debugMode()) {
      console.groupEnd();
    }
  }
}
